export enum DiscountType {
  YEAR_PERCENTAGE = "YEAR_PERCENTAGE",
  YEAR_AMOUNT = "YEAR_AMOUNT",
  MONTH_PERCENTAGE = "MONTH_PERCENTAGE",
  MONTH_AMOUNT = "MONTH_AMOUNT",
  PERCENTAGE = "PERCENTAGE",
  AMOUNT = "AMOUNT",
}